import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MdlSelectModule } from '@angular-mdl/select';
import { FilterComponent} from "./filter";
import { PaginationComponent } from './pagination';
import { FileUploadComponent } from './file-upload/file.upload';
@NgModule({
  declarations: [
   FilterComponent,PaginationComponent,FileUploadComponent
  ],
  imports: [CommonModule,FormsModule,MdlSelectModule],
  exports: [FilterComponent,PaginationComponent,FileUploadComponent],
  providers: []
})
export class CommonAppModule { }



// WEBPACK FOOTER //
// ./src/app/common/common.module.ts